module.exports = __webpack_public_path__ + "0ade7442ebd6579de6b03641681ed1c5.svg";